var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarDelete = function SvgCalendarDelete(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M8 4V3c0-.53-.469-1-1-1-.563 0-1 .469-1 1v1H4.5A1.5 1.5 0 0 0 3 5.5V7h14V5.5c0-.812-.688-1.5-1.5-1.5H14V3c0-.53-.469-1-1-1-.563 0-1 .469-1 1v1zm9 4H3v8.5A1.48 1.48 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5zm-3.933 1.934a.46.46 0 0 0-.647 0L10 12.352 7.582 9.934a.458.458 0 0 0-.647.646L9.353 13l-2.42 2.418a.458.458 0 0 0 .647.647L10 13.646l2.418 2.42a.458.458 0 0 0 .647-.647l-2.418-2.42 2.42-2.418a.46.46 0 0 0 0-.647",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarDelete);
export default ForwardRef;